
const Constants = {
  "locationFilter": {"test": "test"},
  "locations": ["test"],
  "verticalFilter": {"test": "test"},
  "verticals": ["test"],
  "payrollFilter": {"test": "test"},
  "payrolls": ["test"],
  "officeLocationFilter": {"test": "test"},
  "officeLocations": ["test"]
};

export default function constantReducers(state = Constants, action) {
  switch (action.type) {
    case 'GET_CONSTANT_SUCCESS':
      return Object.assign({}, action.constants);
    default :
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/constantReducers.js
 **/